import React from "react";
import appDetails_graph from "../../../assets/images/appDetails_graph.png";
import user_login_frequency_graph from "../../../assets/images/user_login_frequency_graph.png";

const AppDetailOfSite = ({ siteName }) => {
  return (
    <div className="mb-10">
      <div className="ml-4 mt-8 font-bold">
        <p>{siteName}</p>
      </div>

      <div className="ml-4 mt-8 w-[70%]">
        <img
          src={appDetails_graph}
          alt="app details graph"
          className="w-full"
        />
      </div>
      <div className="ml-4 mt-8 w-[70%]">
        <img
          src={user_login_frequency_graph}
          alt="app details graph"
          className="w-full"
        />
      </div>
    </div>
  );
};

export default AppDetailOfSite;
